export default __webpack_public_path__ + "static/media/arrow-left.e9ccff86.svg";